import React, { useId } from 'react';
import { Box, List, Text } from '@applatform/design-system';
import { v2Colors } from 'theme';

interface NavGroupProps {
  readonly children: React.ReactNode;
  readonly label?: string;
}

function NavGroup({ children, label }: NavGroupProps) {
  const labelId = useId();

  return (
    <Box css={{ px: '$2', mb: '$1' }}>
      {label ? (
        <Text
          id={labelId}
          css={{
            px: '$2',
            pt: '$3',
            pb: '$2',
            fontSize: '10.5px',
            fontWeight: '$bold',
            letterSpacing: '0.09em',
            textTransform: 'uppercase',
            color: v2Colors.faint,
          }}
        >
          {label}
        </Text>
      ) : null}
      <List
        role="list"
        aria-labelledby={label ? labelId : undefined}
        css={{ listStyleType: 'none', m: 0, p: 0 }}
      >
        {children}
      </List>
    </Box>
  );
}

export default NavGroup;
